module.exports = __webpack_public_path__ + "img/face24.dfd9536a.gif";